import { render } from "./UpdateGoalsModal.vue?vue&type=template&id=6cfa4878"
import script from "./UpdateGoalsModal.vue?vue&type=script&lang=js"
export * from "./UpdateGoalsModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__